enum SESSION_STATUS {
    off = 0,
    on = 1,
    on_hold = 2,
    in_call = 3
}
export default SESSION_STATUS;